import React, { ChangeEvent, Component } from "react";
import IErrorDTO from "../../../models/DTO/IErrorDTO";
import IOnProcessWarehouseDTO from "../../../models/DTO/IOnProcessWarehouseDTO";
import IProcessWarehouseDTO from "../../../models/DTO/IProcessWarehouseDTO";
import EndpointsEnum from "../../../models/EndpointsEnum";
import INewWarehouse from "../../../models/INewWarehouse";
import INotification from "../../../models/INotification";
import ISupplierModel from "../../../models/ISupplierModel";
import IUserUI from "../../../models/IUser";
import IWarehouse from "../../../models/IWarehouse";
import NotificationLevelEnum from "../../../models/NotificationLevelEnum";
import NotificationPositionEnum from "../../../models/NotificationPositionEnum";
import AddressBlock from "../../shared/AddressBlock/AddressBlock";
import OwButton from "../../shared/OwButton/OwButton";
import OwInputWrapper from "../../shared/OwInputWrapper/OwInputWrapper";
import OwLabel from "../../shared/OwLabel/OwLabel";
import OwTitle from "../../shared/OwTitle/OwTitle";
import { Socket } from "socket.io-client";

import "./WarehouseSidebar.scss";
import OwToggle from "../../shared/OwToggle/OwToggle";
import OwSelectOption from "../../shared/OwSelectOption/OwSelectOption";
import IQBDInventorySiteList from "../../../models/QuickBooks Desktop/IQBDInventorySiteList";
import IQBDClassOption from "../../../models/QuickBooks Desktop/IQBDClassOption";

interface IQBDTemplate {
    ListID: string;
    Name: string;
    IsActive: string; // we only want "true"
    TemplateType: string; // we only want Invoice
}

type Props = {
    cancelFn: (refresh?: boolean) => void;
    notifyFn: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
    socket: Socket;
    userModel: IUserUI;
    supplierModel: ISupplierModel;
    warehouse?: IWarehouse;
};

type State = {
    warehouse: IWarehouse | INewWarehouse;
    isSaveActive: boolean;
};

class WarehouseSidebar extends Component<Props, State> {
    constructor(props: any) {
        super(props);

        this.state = {
            warehouse: this.props.warehouse || ({ Address: {} } as INewWarehouse),
            isSaveActive: false,
        };
    }

    componentDidMount() {
        this.props.socket.on(EndpointsEnum.WarehouseOnProcessWarehouse, this.onProcessWarehouse);
    }

    componentWillUnmount() {
        this.props.socket.removeListener(EndpointsEnum.WarehouseOnProcessWarehouse, this.onProcessWarehouse);
    }

    cancel = () => {
        this.props.cancelFn(false);
    };

    handleChange = (e: ChangeEvent<any>) => {
        const value = e.target.type === "checked" ? e.target.checked : e.target.value;
        const name = e.target.name;

        const warehouse = this.state.warehouse;

        // @ts-expect-error
        warehouse[name] = value;

        this.setState({ warehouse });
    };

    handleAddressChange = (e: ChangeEvent<any>) => {
        const value = e.target.type === "checked" ? e.target.checked : e.target.value;
        const name = e.target.name;

        const warehouse = this.state.warehouse;

        // @ts-expect-error
        warehouse.Address[name] = value;

        this.setState({ warehouse });
    };

    processWarehouse = () => {
        const payload: IProcessWarehouseDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            warehouse: this.state.warehouse,
        };

        this.props.socket.emit(EndpointsEnum.WarehouseProcessWarehouse, payload);
    };

    onProcessWarehouse = (data: IOnProcessWarehouseDTO) => {
        const notification: INotification = {
            message: "successfully_processed_warehouse",
            position: NotificationPositionEnum.bc,
            level: NotificationLevelEnum.success,
        };

        this.props.notifyFn(null, notification);

        this.props.cancelFn(true);
    };

    save = () => {
        this.setState(
            {
                isSaveActive: true,
            },
            () => {
                this.processWarehouse();
            }
        );
    };

    render() {
        const inventorySiteListOptions: IQBDInventorySiteList[] = this.props.supplierModel.Supplier_Integration.qbd_InventorySiteList || [];
        const templateOptions: { ListID: string; Name: string }[] = JSON.parse(
            this.props.supplierModel.Supplier_Integration.qbd_Templates || "[]"
        ).filter((templateItem: any) => templateItem.IsActive === "true" && templateItem.TemplateType === "Invoice");
        const classOptions: IQBDClassOption[] = this.props.supplierModel.Supplier_Integration.qbd_ClassOptions || [];

        return (
            <div className="WarehouseSidebar p-2">
                <div className={"row"}>
                    <div className={"col-12"}>
                        <div className="text-end">
                            <button className="btn btn-danger btn-sm" onClick={this.cancel}>
                                <i className="far fa-times" />
                            </button>
                        </div>
                        <OwTitle className={"mb-2"} leftIconName={"fad fa-warehouse-alt"} title={"warehouse"} />
                        <hr />
                    </div>
                </div>

                <div>
                    <div className={"mb-2"}>
                        <OwLabel title={"name"} />
                        <OwInputWrapper name={"name"} value={this.state.warehouse.name} fn={this.handleChange} />
                    </div>

                    <div className={"mb-2"}>
                        <OwToggle fn={this.handleChange} name={"is_hidden"} label={"is_hidden"} active={!!this.state.warehouse.is_hidden} />
                    </div>

                    <div className={"mb-2"}>
                        <OwLabel title={"address"} />
                        <AddressBlock address={this.state.warehouse.Address} fn={this.handleAddressChange} />
                    </div>
                </div>

                {this.props.supplierModel.Supplier_Integration.has_qbd ? (
                    <div>
                        <div className={"mb-2"}>
                            <OwLabel title={"invoice_template"} postText={":"} />
                            <OwSelectOption
                                name={"qbd_InvoiceTemplateRef"}
                                titleProp={"Name"}
                                valueProp={"ListID"}
                                fn={this.handleChange}
                                options={templateOptions}
                                selectedOption={this.state.warehouse}
                                selectedOptionProp={"qbd_InvoiceTemplateRef"}
                            />
                        </div>

                        <div className={"mb-2"}>
                            <OwLabel title={"item_row_inventory_site"} postText={":"} />
                            <OwSelectOption
                                name={"qbd_ItemRowInventorySiteRef"}
                                titleProp={"Name"}
                                valueProp={"ListID"}
                                fn={this.handleChange}
                                options={inventorySiteListOptions}
                                selectedOption={this.state.warehouse}
                                selectedOptionProp={"qbd_ItemRowInventorySiteRef"}
                            />
                        </div>

                        <div className={"mb-2"}>
                            <OwLabel title={"order_class"} postText={":"} />
                            <OwSelectOption
                                name={"qbd_OrderClassRef"}
                                titleProp={"Name"}
                                valueProp={"ListID"}
                                fn={this.handleChange}
                                options={classOptions}
                                selectedOption={this.state.warehouse}
                                selectedOptionProp={"qbd_OrderClassRef"}
                            />
                        </div>

                        <div className={"mb-2"}>
                            <OwLabel title={"item_row_class"} postText={":"} />
                            <OwSelectOption
                                name={"qbd_ItemRowClassRef"}
                                titleProp={"Name"}
                                valueProp={"ListID"}
                                fn={this.handleChange}
                                options={classOptions}
                                selectedOption={this.state.warehouse}
                                selectedOptionProp={"qbd_ItemRowClassRef"}
                            />
                        </div>
                    </div>
                ) : null}

                <div className={"mt-2"}>
                    <OwButton title={"save"} fn={this.save} active={this.state.isSaveActive} disableOnActive={true} />
                </div>
            </div>
        );
    }
}

export default WarehouseSidebar;
